<template>
  <Popup
    v-if="showNewsletter"
    name="newsletterRequest"
    :show-close-button="true"
    :show-delay="10000"
    :position="'left-bottom'"
    context="global"
  >
    <template v-slot:title>
      {{ t('newsletter.promoTitle') }}<br />
      {{ t('newsletter.promoSubtitle') }}
    </template>
    <template v-slot:actions>
      <button class="button button--secondary" @click="close()">{{ t('newsletter.decline') }}</button>
      <button class="button button--primary" @click="newsletterAgree()">
        {{ t('newsletter.confirm') }}
      </button>
    </template>
  </Popup>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue'
  import Popup from '@/components/popups/Popup.vue'
  import { useAuthStore } from '@/stores/useAuthStore'
  import { useTourStore } from '@/stores/useTourStore'
  import { useSpecificPopup } from '@/composables/useSpecificPopup.ts'
  import { useHttpClient } from '@/composables/useHttpClient'
  import { useStrings } from '@/composables/useStrings.ts'

  const { t } = useStrings()
  const authStore = useAuthStore()
  const tourStore = useTourStore()
  const { proxyApi } = useHttpClient()
  const { isVisible: newsletterPopupVisible } = useSpecificPopup('newsletterRequest')

  const sent = ref(false)

  const showNewsletter = computed(() => {
    const userName = authStore.userName

    return (
      (userName?.length ?? 0) > 0 &&
      userName?.includes('@') &&
      !sent.value &&
      tourStore.isTourComplete &&
      tourStore.isAfterTourComplete &&
      newsletterPopupVisible.value
    )
  })

  const newsletterAgree = async () => {
    //BPE
    try {
      await proxyApi.post(`/newsletter?email=${encodeURIComponent(authStore.userName as string)}`, {})
      sent.value = true
    } catch (err) {
      console.error(err)
    }
  }

  const close = () => {
    sent.value = true
  }
</script>
